import { StepLayout } from 'components/StepLayout/StepLayout';
import React, { FC, useState } from 'react';
import { useTranslation } from '@wix/wix-i18n-config';
import { BI_ACTION_NAME, BI_STEP_NAME } from 'config/bi';
import { biEvents } from 'api/bi-events';
import { StepId } from 'config/steps';
import { useAppStore } from 'stores/appStore';
import { SelectImageStepOptions } from './components/SelectImageStepOptions';
import { SelectImageStepUpload } from './components/SelectImageStepUpload';
import { Collapse, Divider, TextButton } from '@wix/design-system';
import { UploadExport } from '@wix/wix-ui-icons-common';

export const SelectImageStep: FC = () => {
  const { t } = useTranslation();

  const localFile = useAppStore((state) => state.localFile);
  const mediaUrl = useAppStore((state) => state.mediaUrl);
  const setMediaUrl = useAppStore((state) => state.setMediaUrl);

  const [isLocalFileSelected, setIsLocalFileSelected] = useState<boolean>(true);

  return (
    <StepLayout
      disclaimer={t('select-image-step.disclaimer')}
      description={t('select-image-step.description')}
      title={t('select-image-step.title')}
      nextButtonProps={{ label: t('select-image-step.actions.primary-button'), disabled: !localFile && !mediaUrl }}
      onNext={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectImage],
          action: BI_ACTION_NAME.CONTINUE,
        });
      }}
      onBack={() => {
        biEvents.actionClicked({
          screenName: BI_STEP_NAME[StepId.SelectImage],
          action: BI_ACTION_NAME.BACK,
        });
      }}
    >
      <SelectImageStepUpload
        isSelected={isLocalFileSelected}
        onSelect={() => {
          setIsLocalFileSelected(true);
          setMediaUrl(undefined);
        }}
      />
      <Divider />
      <SelectImageStepOptions onItemClick={() => setIsLocalFileSelected(false)} />
    </StepLayout>
  );
};
